<script lang="ts">
  import { format, subDays } from "date-fns";

  import TitledDisplay from "@cohesionib/biblioteca/lib/TitledDisplay";
  import PageBox from "../shared/PageBox.svelte";
  import SnapshotSection from "../shared/SnapshotSection.svelte";
  import AmenityReservationsTenantBreakdown from "./AmenityReservationsTenantBreakdown.svelte";

  let dateTitleStart = format(subDays(new Date(), 3), "MMMM d', 'yyyy'").replaceAll(
    ".",
    ""
  );
  let dateTitleEnd = format(
    new Date(),
    "MMMM d', 'yyyy'"
  ).replaceAll(".", "");
</script>

<style>
  div {
    font-weight: 300;
  }
  .snapshot-child {
    width: 12em;
    padding: 1.5em 2em 1.5em 2em;
  }
  #date-title {
    font-size: 1.5em;
    color: #4e4e4e;
    font-weight: 400;
    padding-bottom: 1em;
  }
  .number {
    font-weight: 300;
    color: var(--theme-accent);
    font-size: 3em;
    line-height: min-content;
  }
  .unit {
    font-size: 1.5em;
    font-weight: 300;
    color: var(--theme-accent);
    line-height: min-content;
  }
  #trend-wrapper {
    padding-top: 2em;
  }
</style>

<PageBox>
  <div class="layout">
    <div id="date-title"><span>{dateTitleStart} - {dateTitleEnd}</span></div>
    <SnapshotSection title="Snapshot">
      <div class="snapshot-child">
        <TitledDisplay
          title="Total Reservations"
          subtitle="Total number of reservations requested">
          <div><span class="number">207</span></div>
        </TitledDisplay>
      </div>
      <div class="snapshot-child">
        <TitledDisplay
          title="Amenity Utilization"
          subtitle="Overall untilization of the building's amenities">
          <div><span class="number">65%</span></div>
        </TitledDisplay>
      </div>
      <div class="snapshot-child">
        <TitledDisplay
          title="Amenity Approval Time"
          subtitle="Average time to approve a reservation request">
          <div><span class="number">4</span> <span class="unit">hrs</span></div>
        </TitledDisplay>
      </div>
    </SnapshotSection>
    <div id="trend-wrapper">
      <AmenityReservationsTenantBreakdown />
    </div>
  </div>
</PageBox>
